import { IDWAppAlert } from "@idw-types/common/idw-app-alert";
import { useDispatch } from "react-redux";
import { removeAppAlert } from "@redux/actions/app-alerts-actions";
import { useEffect, useMemo } from "react";
import { IDWAppAlertTypes } from "@enums/idw-app-alert-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons/faExclamationTriangle";
import { faCheck } from "@fortawesome/free-solid-svg-icons/faCheck";
import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes";
import classNames from "classnames";
import styles from "./app-alert-container.less";

type AppAlertContainerProps = {
    appAlert: IDWAppAlert;
}

export const AppAlertContainer = (props: AppAlertContainerProps) => {
    const dispatch = useDispatch();
    const { appAlert } = props;

    useEffect(() => {
        setTimeout(() => {
            dispatch(removeAppAlert(appAlert.id));
        }, appAlert.detailedMessage ? 10000 : 5000);
    }, []);

    const onClickClose = () => {
        dispatch(removeAppAlert(appAlert.id));
    };

    const { icon, containerClassName } = useMemo(() => {
        switch (appAlert.type) {
            case IDWAppAlertTypes.ERROR:
                return { icon: faExclamationTriangle, containerClassName: styles.errorContainer };
            case IDWAppAlertTypes.SUCCESS:
                return { icon: faCheck, containerClassName: styles.successContainer }
            default:
                return { icon: null, containerClassName: "" };
        }
    }, [appAlert.type]);

    const extractDetailedMessage = (detailedMessageObject: { [key: string]: any }) => {
        if (detailedMessageObject["message"]) {
            return `<span>${detailedMessageObject["message"]}</span>`;
        }
        return null;
    };

    const detailedMessage: string = useMemo(() => {
        if (appAlert.detailedMessage) {
            if (typeof appAlert.detailedMessage === "string") {
                try {
                    const jsonMessage = JSON.parse(appAlert.detailedMessage);
                    return extractDetailedMessage(jsonMessage);
                } catch (error) {
                    console.error(`Error extracting detailed message JSON: ${error}`);
                    return null;
                }
            }
            if (typeof appAlert.detailedMessage === "object") {
                return extractDetailedMessage(appAlert.detailedMessage);
            } else {
                return `<span>${appAlert.detailedMessage}</span>`;
            }
        }
        return null;
    }, [appAlert.detailedMessage]);

    return (
        <div className={classNames(styles.appAlertContainer, containerClassName)}>
            <div className={styles.alertIconContainer}>
                <FontAwesomeIcon icon={icon} className={styles.alertIcon} />
            </div>
            <div className={styles.contentContainer}>
                <div className={styles.titleContainer}>
                    <span className={styles.title}>{appAlert.title}</span>
                </div>
                <div className={styles.messageContainer}>
                    <span className={styles.message}>{appAlert.message}</span>
                </div>
                {detailedMessage && (
                    <div className={styles.detailedMessageContainer}>
                        <span className={styles.detailedMessageTitle}>Details:</span>
                        <div className={styles.detailedMessage} dangerouslySetInnerHTML={{ __html: detailedMessage }} />
                    </div>
                )}
            </div>
            <div className={styles.closeIconContainer}>
                <FontAwesomeIcon icon={faTimes} className={styles.closeIcon} onClick={onClickClose} />
            </div>
        </div>
    );
};